import { axiosDS } from '@pp/axios'
import { urls } from 'Constants/Urls'
import {
	ChatModel,
	isReadedModelParams,
	MessageModel,
	RatingModelParams,
	SentFile,
	getContourChat,
	UploadFileParams,
} from 'Pages/chat'
import { serialize } from 'object-to-formdata'
import { RequestParams, ResponseCatalog, SettingModel } from 'Models'

const urlChat = getContourChat(true)

export const chatApi = {
	getSessionToken: async () => {
		const res = await axiosDS().get<{ token: string }>(urls.chat.session)
		return res.data
	},

	createChat: async (token: string, data: Partial<Record<string, string>>) => {
		const res = await axiosDS().post<ChatModel>(`${urlChat}${urls.chat.index}`, data, {
			headers: {
				Authorization: `${token}`,
			},
		})

		return res.data
	},

	getChats: async (token: string, params: Record<string, unknown>) => {
		const res = await axiosDS().get<ResponseCatalog<ChatModel>>(`${urlChat}${urls.chat.index}`, {
			params,
			headers: {
				Authorization: `${token}`,
			},
		})
		return res.data
	},
	getMessages: async (token: string, params: RequestParams) => {
		const res = await axiosDS({ isExternal: true }).get<ResponseCatalog<MessageModel>>(
			`${urlChat}messages`,
			{
				params,
				headers: {
					Authorization: `${token}`,
				},
			}
		)
		return res.data
	},
	setUnreadedMessages: async (data: isReadedModelParams) => {
		const { message_ids, chat_id, token } = data
		const res = await fetch(`${urlChat}messages/read`, {
			headers: {
				Authorization: `${token}`,
			},
			method: 'post',
			body: serialize({ message_ids, chat_id }),
		}).then((response) => {
			return response
		})
		return res
	},
	setRating: async (data: RatingModelParams) => {
		const { id, score, score_comment, token } = data
		const res = await fetch(`${urlChat}tickets/${id}`, {
			headers: {
				Authorization: `${token}`,
			},
			method: 'PATCH',
			body: serialize({ score, score_comment }),
		}).then((response) => {
			return response
		})
		return res
	},
	uploadFile: async (data: UploadFileParams) => {
		const { file, chat_id, role_name, user_name, reply_to_message_id, token } = data
		const formData = serialize({ file, chat_id, role_name, user_name, reply_to_message_id })
		const res: SentFile = await fetch(`${urlChat}chat_files`, {
			headers: {
				Authorization: `${token}`,
			},
			method: 'POST',
			body: formData,
		})
			.then((response) => response.json())
			.then((response) => {
				return response
			})
		return res
	},
	getFiles: async (token: string, chat_id: number, page: number, per_page: number) => {
		const prepareParams = `page=${page}&per_page=${per_page}&q[chat_id_eq]=${chat_id}&q[s]=created_at DESC`
		const res: SentFile[] = await fetch(`${urlChat}chat_files?${prepareParams}`, {
			headers: {
				Authorization: `${token}`,
			},
		})
			.then((response) => response.json())
			.then((response) => {
				return response
			})
		return res
	},
	downloadFile: async (token: string, id: number) => {
		return fetch(`${urlChat}chat_files/${id}`, {
			headers: {
				Authorization: `${token}`,
			},
		})
	},
	fullTextSearch: async (token: string, params: RequestParams) => {
		const res = await axiosDS({ isExternal: true }).get<ResponseCatalog<MessageModel>>(
			`${urlChat}messages/full_text_search`,
			{
				params,
				headers: {
					Authorization: `${token}`,
				},
			}
		)
		return res.data
	},
	getSettings: async () => {
		const res = await axiosDS().get<SettingModel>(urls.chat.settings)
		return res.data
	},
}
